import { useState, useCallback } from "react";
import type { App, ApiResponse } from "../types/api";

const USER_UUID = "550e8400-e29b-41d4-a716-446655440001";
type TabType = "current" | "archived" | "all";

export const useApps = (activeTab: TabType) => {
  const [apps, setApps] = useState<App[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchApps = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const filterParam = activeTab === "current" ? "" : `?filter=${activeTab}`;
      const response = await fetch(
        `http://10.0.10.237:5000/api/fetch_apps${filterParam}`,
        {
          mode: "cors",
          headers: {
            "X-User-UUID": USER_UUID,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      const data: ApiResponse = await response.json();
      console.log("Fetched apps:", data.apps); // Add this log
      setApps(data.apps || []);
    } catch (fetchError) {
      setError("Failed to load apps");
      console.error("Failed to fetch apps:", fetchError);
    } finally {
      setLoading(false);
    }
  }, [activeTab]);

  const handleArchiveToggle = useCallback(
    async (app: App) => {
      console.log("Toggling app archived state:", app.archived); // Updated log
      try {
        const response = await fetch(
          "http://10.0.10.237:5000/api/archive_app",
          {
            method: "POST",
            mode: "cors",
            headers: {
              "X-User-UUID": USER_UUID,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              message_id: app.message_id,
              archived: !app.archived, // Toggle based on archived property
            }),
          }
        );

        if (response.ok) {
          fetchApps();
        } else {
          console.error(
            "Failed to archive/unarchive app:",
            await response.text()
          );
        }
      } catch (archiveError) {
        console.error("Failed to archive/unarchive app:", archiveError);
      }
    },
    [fetchApps]
  );

  return {
    apps,
    loading,
    error,
    fetchApps,
    handleArchiveToggle,
  };
};
